import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/payroll-engine-mock/payroll-structures'
    });
  }
});